import RatingStars from '@/storybook/components/RatingStarts/RatingStars';
import { SelectItem } from '@/types/ui';
import styles from './DropdownItemLabelWithRatingsStars.module.css';

export type DropdownItemLabelWithRatingstarsProps<T> = {
  option: SelectItem<T>;
  value: SelectItem<T>[];
  onEdit: (option: SelectItem<T>) => void;
};

export default function DropdownItemLabelWithRatingsStars<T>({
  option,
  value,
  onEdit,
}: DropdownItemLabelWithRatingstarsProps<T>) {
  const correspondingValue = value.find(currVal => currVal.value === option.value);
  return (
    <div className={styles.multiLevelSelectedOption} data-testid={`checkboxWithRating-${option.value}`}>
      <span>{option.label}</span>{' '}
      {correspondingValue && (
        <RatingStars
          rate={correspondingValue.level ?? 0}
          onClick={() => onEdit(option)}
          data-testid={`ratingStars-${option.value}`}
        />
      )}
    </div>
  );
}
